export const LIST_API_LIMIT = 13;

export const VARIABLE_UPDATE_TYPE = {
  KEY: 'KEY',
  VALUE: 'VALUE',
  ALL: 'ALL',
  RESET: 'RESET',
};

const i18nKeys = {
  pageHeading: 'environments.listpage.heading',
  name: 'common.default.field.label.name',
  createdAtEpoch: 'common.created_at_epoch.label',
  updatedAtEpoch: 'common.updated_at_epoch.label',
  createdBy: 'common.createdby.label',
  activity: 'common.activity.label',
  createEnv: 'create.environment.label',
  emptySearch: 'common.listpage.empty_search.message',
  emptyEnvironments: 'environments.listpage.no_entities.message',
};

const ListColSections = {
  title: {
    label: i18nKeys.name,
    sortName: 'name',
  },
  createdBy: {
    label: i18nKeys.createdBy,
    sortName: 'createdById',
  },
  activity: {
    label: i18nKeys.activity,
  },
};

const sortOptions = [
  {
    label: i18nKeys.name,
    key: 'name',
  },
  {
    label: i18nKeys.createdAtEpoch,
    key: 'createdAtEpoch',
  },
  {
    label: i18nKeys.updatedAtEpoch,
    key: 'updatedAtEpoch',
  },
];
